import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function getRecentTestResultsAPI(authToken: string): Observable<any> {
    return educatAPI.get(
        `test_realisations/most_recent_results`,
        new RestQueryParams(),
        {
            Authorization: `Bearer ${authToken}`
        }
    );
}
